export function componentNameToString(name: string | symbol): string {
    if (typeof name === 'string') {
        return name;
    } else {
        return name.toString();
    }
}

export function toString(item: string | symbol): string {
    if (typeof item === 'string') {
        return item;
    } else {
        return item.description ?? item.toString();
    }
}
